var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "door-window-garage-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HK---Inventory",
    transform: "translate(-40.000000, -306.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Document-Manual-Card-Copy-7",
    transform: "translate(16.000000, 282.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "door-window-garage-icon",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29,30 L31,30 C31.5522847,30 32,30.4477153 32,31 C32,31.5522847 31.5522847,32 31,32 L1,32 C0.44771525,32 6.76353751e-17,31.5522847 0,31 C-6.76353751e-17,30.4477153 0.44771525,30 1,30 L3,30 L3,2 C3,0.8954305 3.8954305,0 5,0 L27,0 C28.1045695,0 29,0.8954305 29,2 L29,30 Z M15,17 L5,17 L5,30 L15,30 L15,17 Z M27,17 L17,17 L17,30 L27,30 L27,17 Z M15,2 L5,2 L5,15 L15,15 L15,2 Z M27,2 L17,2 L17,15 L27,15 L27,2 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindow);
export default __webpack_public_path__ + "static/media/window.fc247021aa868c561d8eeed43ef05d58.svg";
export { ForwardRef as ReactComponent };